import React, { useContext } from 'react'
import SocialMedia from './SocialMedia';
import { Link } from 'react-router-dom';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { CardContext } from '../../../store/CardContext';

function SlideSocialMediaStd({ preview, color,iconColor, Highlightcolor }) {


   
    const BgColor = Highlightcolor !== '#000000' ? Highlightcolor : '#efefef'

    const [cardData] = useContext(CardContext)

    const {SMediaPostion, socialMediaDetails } = cardData;

    const slideLeft = () => {
        var slider = document.getElementById("slider");
        slider.scrollLeft = slider.scrollLeft - 100;
    };
    const slideRight = () => {
        var slider = document.getElementById("slider");
        slider.scrollLeft = slider.scrollLeft + 100;
    };

    const data = {
        //--------------------------------------FacebookSvg-----------------------------------------------
        FaceBookIcon: (
            <Link
                className='w-[54px] h-[54px] flex justify-center items-center rounded-md'
                style={{ background: `${BgColor}` }}
                to={`${preview ? socialMediaDetails?.facebook : ""}`}
                target={`${preview ? "_blank" : ""}`}
            >
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M44 24C44 12.96 35.04 4 24 4C12.96 4 4 12.96 4 24C4 33.68 10.88 41.74 20 43.6V30H16V24H20V19C20 15.14 23.14 12 27 12H32V18H28C26.9 18 26 18.9 26 20V24H32V30H26V43.9C36.1 42.9 44 34.38 44 24Z"
                        fill={iconColor}
                    />
                </svg>
            </Link>
        ),
        //--------------------------------------InstagramSvg-----------------------------------------------

        InstagramIcon: (
            <Link
                className='w-[54px] h-[54px] flex justify-center items-center rounded-md'
                style={{ background: `${BgColor}` }}
                to={`${preview ? socialMediaDetails?.instagram : ""}`}
                target={`${preview ? "_blank" : ""}`}
            >
                <svg
                    width="28"
                    height="28"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.6 0H28.4C34.8 0 40 5.2 40 11.6V28.4C40 31.4765 38.7779 34.427 36.6024 36.6024C34.427 38.7779 31.4765 40 28.4 40H11.6C5.2 40 0 34.8 0 28.4V11.6C0 8.52349 1.22214 5.57298 3.39756 3.39756C5.57298 1.22214 8.52349 0 11.6 0ZM11.2 4C9.29044 4 7.45909 4.75857 6.10883 6.10883C4.75857 7.45909 4 9.29044 4 11.2V28.8C4 32.78 7.22 36 11.2 36H28.8C30.7096 36 32.5409 35.2414 33.8912 33.8912C35.2414 32.5409 36 30.7096 36 28.8V11.2C36 7.22 32.78 4 28.8 4H11.2ZM30.5 7C31.163 7 31.7989 7.26339 32.2678 7.73223C32.7366 8.20107 33 8.83696 33 9.5C33 10.163 32.7366 10.7989 32.2678 11.2678C31.7989 11.7366 31.163 12 30.5 12C29.837 12 29.2011 11.7366 28.7322 11.2678C28.2634 10.7989 28 10.163 28 9.5C28 8.83696 28.2634 8.20107 28.7322 7.73223C29.2011 7.26339 29.837 7 30.5 7ZM20 10C22.6522 10 25.1957 11.0536 27.0711 12.9289C28.9464 14.8043 30 17.3478 30 20C30 22.6522 28.9464 25.1957 27.0711 27.0711C25.1957 28.9464 22.6522 30 20 30C17.3478 30 14.8043 28.9464 12.9289 27.0711C11.0536 25.1957 10 22.6522 10 20C10 17.3478 11.0536 14.8043 12.9289 12.9289C14.8043 11.0536 17.3478 10 20 10ZM20 14C18.4087 14 16.8826 14.6321 15.7574 15.7574C14.6321 16.8826 14 18.4087 14 20C14 21.5913 14.6321 23.1174 15.7574 24.2426C16.8826 25.3679 18.4087 26 20 26C21.5913 26 23.1174 25.3679 24.2426 24.2426C25.3679 23.1174 26 21.5913 26 20C26 18.4087 25.3679 16.8826 24.2426 15.7574C23.1174 14.6321 21.5913 14 20 14Z"
                        fill={iconColor}
                    />
                </svg>
            </Link>
        ),
        //--------------------------------------WhatsAppSvg-----------------------------------------------
        WhatsAppIcon: (
            <Link
                className='w-[54px] h-[54px] flex justify-center items-center rounded-md'
                style={{ background: `${BgColor}` }}
                to={`https://wa.me/+${preview ? socialMediaDetails?.whatsappNumber : ""
                    }?text=Hi%2C`}
                target={`${preview ? "_blank" : ""}`}
            >
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M38.0996 9.82012C36.266 7.96797 34.082 6.49945 31.6749 5.50022C29.2678 4.50099 26.6858 3.99104 24.0796 4.00012C13.1596 4.00012 4.25961 12.9001 4.25961 23.8201C4.25961 27.3201 5.17961 30.7201 6.89961 33.7201L4.09961 44.0001L14.5996 41.2401C17.4996 42.8201 20.7596 43.6601 24.0796 43.6601C34.9996 43.6601 43.8996 34.7601 43.8996 23.8401C43.8996 18.5401 41.8396 13.5601 38.0996 9.82012ZM24.0796 40.3001C21.1196 40.3001 18.2196 39.5001 15.6796 38.0001L15.0796 37.6401L8.83961 39.2801L10.4996 33.2001L10.0996 32.5801C8.4551 29.9541 7.58189 26.9186 7.57961 23.8201C7.57961 14.7401 14.9796 7.34012 24.0596 7.34012C28.4596 7.34012 32.5996 9.06012 35.6996 12.1801C37.2346 13.708 38.451 15.5254 39.2784 17.527C40.1058 19.5285 40.5277 21.6743 40.5196 23.8401C40.5596 32.9201 33.1596 40.3001 24.0796 40.3001ZM33.1196 27.9801C32.6196 27.7401 30.1796 26.5401 29.7396 26.3601C29.2796 26.2001 28.9596 26.1201 28.6196 26.6001C28.2796 27.1001 27.3396 28.2201 27.0596 28.5401C26.7796 28.8801 26.4796 28.9201 25.9796 28.6601C25.4796 28.4201 23.8796 27.8801 21.9996 26.2001C20.5196 24.8801 19.5396 23.2601 19.2396 22.7601C18.9596 22.2601 19.1996 22.0001 19.4596 21.7401C19.6796 21.5201 19.9596 21.1601 20.1996 20.8801C20.4396 20.6001 20.5396 20.3801 20.6996 20.0601C20.8596 19.7201 20.7796 19.4401 20.6596 19.2001C20.5396 18.9601 19.5396 16.5201 19.1396 15.5201C18.7396 14.5601 18.3196 14.6801 18.0196 14.6601H17.0596C16.7196 14.6601 16.1996 14.7801 15.7396 15.2801C15.2996 15.7801 14.0196 16.9801 14.0196 19.4201C14.0196 21.8601 15.7996 24.2201 16.0396 24.5401C16.2796 24.8801 19.5396 29.8801 24.4996 32.0201C25.6796 32.5401 26.5996 32.8401 27.3196 33.0601C28.4996 33.4401 29.5796 33.3801 30.4396 33.2601C31.3996 33.1201 33.3796 32.0601 33.7796 30.9001C34.1996 29.7401 34.1996 28.7601 34.0596 28.5401C33.9196 28.3201 33.6196 28.2201 33.1196 27.9801Z"
                        fill={iconColor}
                    />
                </svg>
            </Link>
        ),
        //--------------------------------------LinkedInSvg-----------------------------------------------
        LinkedInIcon: (
            <Link
                className='w-[54px] h-[54px] flex justify-center items-center rounded-md'
                style={{ background: `${BgColor}` }}
                to={`${preview ? socialMediaDetails?.linkedin : ""}`}
                target={`${preview ? "_blank" : ""}`}
            >
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M38 6C39.0609 6 40.0783 6.42143 40.8284 7.17157C41.5786 7.92172 42 8.93913 42 10V38C42 39.0609 41.5786 40.0783 40.8284 40.8284C40.0783 41.5786 39.0609 42 38 42H10C8.93913 42 7.92172 41.5786 7.17157 40.8284C6.42143 40.0783 6 39.0609 6 38V10C6 8.93913 6.42143 7.92172 7.17157 7.17157C7.92172 6.42143 8.93913 6 10 6H38ZM37 37V26.4C37 24.6708 36.3131 23.0124 35.0903 21.7897C33.8676 20.5669 32.2092 19.88 30.48 19.88C28.78 19.88 26.8 20.92 25.84 22.48V20.26H20.26V37H25.84V27.14C25.84 25.6 27.08 24.34 28.62 24.34C29.3626 24.34 30.0748 24.635 30.5999 25.1601C31.125 25.6852 31.42 26.3974 31.42 27.14V37H37ZM13.76 17.12C14.6511 17.12 15.5058 16.766 16.1359 16.1359C16.766 15.5058 17.12 14.6511 17.12 13.76C17.12 11.9 15.62 10.38 13.76 10.38C12.8636 10.38 12.0039 10.7361 11.37 11.37C10.7361 12.0039 10.38 12.8636 10.38 13.76C10.38 15.62 11.9 17.12 13.76 17.12ZM16.54 37V20.26H11V37H16.54Z"
                        fill={iconColor}
                    />
                </svg>
            </Link>
        ),
        //--------------------------------------TwitterSvg-----------------------------------------------
        TwitterIcon: (
            <Link
                className='w-[54px] h-[54px] flex justify-center items-center rounded-md'
                style={{ background: `${BgColor}` }}
                to={`${preview ? socialMediaDetails?.twitter : ""}`}
                target={`${preview ? "_blank" : ""}`}
            >
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M36.4097 4.5H43.0257L28.5717 21.02L45.5757 43.5H32.2597L21.8317 29.866L9.89969 43.5H3.27969L18.7397 25.83L2.42969 4.5H16.0797L25.5057 16.962L36.4057 4.5H36.4097ZM34.0877 39.54H37.7537L14.0897 8.252H10.1557L34.0877 39.54Z"
                        fill={iconColor}
                    />
                </svg>
            </Link>
        ),
        //--------------------------------------YoutubeSvg-----------------------------------------------
        YoutubeIcon: (
            <Link
                className='w-[54px] h-[54px] flex justify-center items-center rounded-md'
                style={{ background: `${BgColor}` }}
                to={`${preview ? socialMediaDetails?.youtube : ""}`}
                target={`${preview ? "_blank" : ""}`}
            >
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M20 30L30.38 24L20 18V30ZM43.12 14.34C43.38 15.28 43.56 16.54 43.68 18.14C43.82 19.74 43.88 21.12 43.88 22.32L44 24C44 28.38 43.68 31.6 43.12 33.66C42.62 35.46 41.46 36.62 39.66 37.12C38.72 37.38 37 37.56 34.36 37.68C31.76 37.82 29.38 37.88 27.18 37.88L24 38C15.62 38 10.4 37.68 8.34 37.12C6.54 36.62 5.38 35.46 4.88 33.66C4.62 32.72 4.44 31.46 4.32 29.86C4.18 28.26 4.12 26.88 4.12 25.68L4 24C4 19.62 4.32 16.4 4.88 14.34C5.38 12.54 6.54 11.38 8.34 10.88C9.28 10.62 11 10.44 13.64 10.32C16.24 10.18 18.62 10.12 20.82 10.12L24 10C32.38 10 37.6 10.32 39.66 10.88C41.46 11.38 42.62 12.54 43.12 14.34Z"
                        fill={iconColor}
                    />
                </svg>
            </Link>
        ),
        //--------------------------------------SkypeSvg-----------------------------------------------
        SkypeIcon: (
            <Link
                className='w-[54px] h-[54px] flex justify-center items-center rounded-md'
                style={{ background: `${BgColor}` }}
                to={`${preview ? socialMediaDetails?.skype : ""}`}
                target={`${preview ? "_blank" : ""}`}
            >
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M36 12C40.14 16.08 41.7 21.78 40.72 27.1C41.54 28.54 42 30.22 42 32C42 34.6522 40.9464 37.1957 39.0711 39.0711C37.1957 40.9464 34.6522 42 32 42C30.22 42 28.54 41.54 27.1 40.72C21.78 41.7 16.08 40.14 12 36C7.86 31.92 6.3 26.22 7.28 20.9C6.46 19.46 6 17.78 6 16C6 13.3478 7.05357 10.8043 8.92893 8.92893C10.8043 7.05357 13.3478 6 16 6C17.78 6 19.46 6.46 20.9 7.28C26.22 6.3 31.92 7.86 36 12ZM24.08 34.32C29.82 34.32 32.68 31.56 32.68 27.84C32.68 25.46 31.56 22.92 27.22 21.94L23.24 21.06C21.72 20.72 20 20.26 20 18.84C20 17.4 21.2 16.4 23.4 16.4C27.86 16.4 27.44 19.46 29.66 19.46C30.82 19.46 31.82 18.78 31.82 17.6C31.82 14.86 27.44 12.8 23.72 12.8C19.7 12.8 15.4 14.52 15.4 19.08C15.4 21.28 16.18 23.62 20.5 24.7L25.88 26.06C27.5 26.46 27.9 27.36 27.9 28.2C27.9 29.56 26.54 30.9 24.08 30.9C19.26 30.9 19.92 27.2 17.34 27.2C16.18 27.2 15.34 28 15.34 29.14C15.34 31.36 18 34.32 24.08 34.32Z"
                        fill={iconColor}
                    />
                </svg>
            </Link>
        ),
        //--------------------------------------SnapChatSvg-----------------------------------------------
        SnapChatIcon: (
            <Link
                className='w-[54px] h-[54px] flex justify-center items-center rounded-md'
                style={{ background: `${BgColor}` }}
                to={`${preview ? socialMediaDetails?.snapchat : ""}`}
                target={`${preview ? "_blank" : ""}`}
            >
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M23.744 43.53C21.364 43.53 19.776 42.406 18.358 41.416C17.35 40.702 16.406 40.024 15.292 39.836C14.7616 39.7447 14.2242 39.7005 13.686 39.704C12.742 39.704 11.992 39.846 11.458 39.954C11.118 40.014 10.834 40.07 10.61 40.07C10.378 40.07 10.084 40.006 9.97002 39.614C9.87002 39.294 9.80802 38.99 9.74602 38.696C9.58602 37.956 9.45202 37.502 9.17402 37.456C6.19602 37.002 4.41402 36.316 4.06602 35.504C4.03802 35.416 4.00402 35.324 4.00402 35.254C3.98402 35.006 4.16402 34.8 4.41402 34.754C6.77602 34.364 8.89802 33.106 10.69 31.038C12.082 29.432 12.76 27.88 12.822 27.712C12.822 27.692 12.84 27.692 12.84 27.692C13.18 26.99 13.25 26.392 13.044 25.902C12.66 24.982 11.394 24.59 10.53 24.322C10.308 24.262 10.12 24.19 9.96002 24.136C9.22002 23.842 7.98802 23.216 8.15002 22.352C8.26602 21.728 9.09402 21.282 9.77202 21.282C9.96002 21.282 10.12 21.31 10.252 21.382C11.012 21.728 11.698 21.906 12.286 21.906C13.018 21.906 13.366 21.63 13.454 21.542C13.4354 21.1464 13.4121 20.751 13.384 20.356C13.204 17.626 13 14.238 13.864 12.296C16.46 6.482 21.97 6.016 23.602 6.016L24.314 6H24.414C26.044 6 31.554 6.454 34.15 12.278C35.024 14.22 34.81 17.618 34.63 20.338L34.612 20.472C34.596 20.836 34.568 21.184 34.552 21.542C34.64 21.612 34.96 21.88 35.62 21.888C36.192 21.872 36.816 21.684 37.528 21.362C37.7251 21.2768 37.9373 21.2319 38.152 21.23C38.402 21.23 38.652 21.29 38.866 21.362H38.884C39.482 21.586 39.874 22.004 39.874 22.442C39.892 22.852 39.57 23.476 38.046 24.092C37.886 24.152 37.698 24.226 37.476 24.278C36.628 24.538 35.362 24.948 34.96 25.858C34.738 26.338 34.826 26.954 35.166 27.65C35.166 27.666 35.184 27.666 35.184 27.666C35.282 27.916 37.858 33.766 43.592 34.72C43.7092 34.7398 43.8153 34.8013 43.8907 34.8932C43.9661 34.9851 44.0056 35.1012 44.002 35.22C44.0034 35.3098 43.9821 35.3986 43.94 35.478C43.592 36.298 41.826 36.966 38.83 37.43C38.554 37.474 38.42 37.93 38.26 38.67C38.1965 38.9784 38.1225 39.2846 38.038 39.588C37.948 39.882 37.76 40.042 37.438 40.042H37.396C37.1109 40.0364 36.8269 40.0036 36.548 39.944C35.815 39.7878 35.0675 39.71 34.318 39.712C33.7806 39.7132 33.2442 39.758 32.714 39.846C31.608 40.026 30.654 40.712 29.646 41.426C28.21 42.406 26.614 43.53 24.252 43.53H23.744Z"
                        fill={iconColor}
                    />
                </svg>
            </Link>
        ),
        //--------------------------------------TikTokSvg-----------------------------------------------
        TikTokIcon: (
            <Link
                className='w-[54px] h-[54px] flex justify-center items-center rounded-md'
                style={{ background: `${BgColor}` }}
                to={`${preview ? socialMediaDetails?.tiktok : ""}`}
                target={`${preview ? "_blank" : ""}`}
            >
                <svg
                    width="32"
                    height="32"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M33.2 11.64C31.8329 10.0792 31.0794 8.07486 31.08 6H24.9V30.8C24.8523 32.142 24.2857 33.4132 23.3195 34.3459C22.3533 35.2785 21.0629 35.7998 19.72 35.8C16.88 35.8 14.52 33.48 14.52 30.6C14.52 27.16 17.84 24.58 21.26 25.64V19.32C14.36 18.4 8.32001 23.76 8.32001 30.6C8.32001 37.26 13.84 42 19.7 42C25.98 42 31.08 36.9 31.08 30.6V18.02C33.586 19.8197 36.5947 20.7853 39.68 20.78V14.6C39.68 14.6 35.92 14.78 33.2 11.64Z"
                        fill={iconColor}
                    />
                </svg>
            </Link>
        ),
        //--------------------------------------CompanyProfileSvg-----------------------------------------------
        CompanyProfileIcon: (
            <Link
                className='w-[54px] h-[54px] flex justify-center items-center rounded-md'
                style={{ background: `${BgColor}` }}
                to={`${preview ? socialMediaDetails?.companyProfile : ""}`}
                target={`${preview ? "_blank" : ""}`}
            >
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.12 0H0.88C0.39325 0 0 0.39325 0 0.88V21.12C0 21.6068 0.39325 22 0.88 22H21.12C21.6068 22 22 21.6068 22 21.12V0.88C22 0.39325 21.6068 0 21.12 0ZM20.02 20.02H1.98V1.98H20.02V20.02ZM10.45 7.92H15.51C15.631 7.92 15.73 7.821 15.73 7.7V6.38C15.73 6.259 15.631 6.16 15.51 6.16H10.45C10.329 6.16 10.23 6.259 10.23 6.38V7.7C10.23 7.821 10.329 7.92 10.45 7.92ZM10.45 11.88H15.51C15.631 11.88 15.73 11.781 15.73 11.66V10.34C15.73 10.219 15.631 10.12 15.51 10.12H10.45C10.329 10.12 10.23 10.219 10.23 10.34V11.66C10.23 11.781 10.329 11.88 10.45 11.88ZM10.45 15.84H15.51C15.631 15.84 15.73 15.741 15.73 15.62V14.3C15.73 14.179 15.631 14.08 15.51 14.08H10.45C10.329 14.08 10.23 14.179 10.23 14.3V15.62C10.23 15.741 10.329 15.84 10.45 15.84ZM6.27 7.04C6.27 7.33174 6.38589 7.61153 6.59218 7.81782C6.79847 8.02411 7.07826 8.14 7.37 8.14C7.66174 8.14 7.94153 8.02411 8.14782 7.81782C8.35411 7.61153 8.47 7.33174 8.47 7.04C8.47 6.74826 8.35411 6.46847 8.14782 6.26218C7.94153 6.05589 7.66174 5.94 7.37 5.94C7.07826 5.94 6.79847 6.05589 6.59218 6.26218C6.38589 6.46847 6.27 6.74826 6.27 7.04ZM6.27 11C6.27 11.2917 6.38589 11.5715 6.59218 11.7778C6.79847 11.9841 7.07826 12.1 7.37 12.1C7.66174 12.1 7.94153 11.9841 8.14782 11.7778C8.35411 11.5715 8.47 11.2917 8.47 11C8.47 10.7083 8.35411 10.4285 8.14782 10.2222C7.94153 10.0159 7.66174 9.9 7.37 9.9C7.07826 9.9 6.79847 10.0159 6.59218 10.2222C6.38589 10.4285 6.27 10.7083 6.27 11ZM6.27 14.96C6.27 15.2517 6.38589 15.5315 6.59218 15.7378C6.79847 15.9441 7.07826 16.06 7.37 16.06C7.66174 16.06 7.94153 15.9441 8.14782 15.7378C8.35411 15.5315 8.47 15.2517 8.47 14.96C8.47 14.6683 8.35411 14.3885 8.14782 14.1822C7.94153 13.9759 7.66174 13.86 7.37 13.86C7.07826 13.86 6.79847 13.9759 6.59218 14.1822C6.38589 14.3885 6.27 14.6683 6.27 14.96Z"       fill={iconColor}/>
        </svg>
            </Link>
        ),
    }

    return (
        <div className="flex jutify-center items-center mb-3">
            {" "}
            {SMediaPostion?.pos5 ? (

                <IoIosArrowBack size={28} color={iconColor} onClick={slideLeft} className='cursor-pointer' />
            ) : (
                ""
            )}
            <div
                className="flex gap-5 overflow-x-scroll scrollbar-hide"
                id="slider"
                style={{ width: "320px" }}
            >
                <div className=" flex gap-[25px] m-0 justify-center  items-center">
                    <SocialMedia data={data} />
                </div>
            </div>
            {SMediaPostion?.pos5 ? (

                <IoIosArrowForward size={28} color={iconColor} onClick={slideRight} className='cursor-pointer' />
            ) : (
                ""
            )}
        </div>
    )
}

export default SlideSocialMediaStd